import { defineStore } from 'pinia';
import { getItem, setItem } from '@/utils/localStorage';

const THEME_KEY = 'theme_preference';

export const useThemeStore = defineStore('theme', {
    state: () => ({
        preference: 'system',
        resolved: 'light',
    }),

    getters: {
        isDark: (state) => state.resolved === 'dark',
        isLight: (state) => state.resolved === 'light',
    },

    actions: {
        initialize(serverPreference = null) {
            const localPref = getItem(THEME_KEY);
            this.preference = serverPreference || localPref || 'system';
            if (serverPreference && serverPreference !== localPref) {
                setItem(THEME_KEY, serverPreference);
            }
            this.applyTheme();
            this.setupSystemListener();
        },

        setPreference(pref, saveToServer = true) {
            this.preference = pref;
            setItem(THEME_KEY, pref);
            this.applyTheme();

            if (saveToServer) {
                this.saveToServer();
            }
        },

        applyTheme() {
            const html = document.documentElement;

            if (this.preference === 'system') {
                const systemDark = window.matchMedia(
                    '(prefers-color-scheme: dark)'
                ).matches;
                this.resolved = systemDark ? 'dark' : 'light';
            } else {
                this.resolved = this.preference;
            }

            if (this.resolved === 'dark') {
                html.classList.add('dark');
            } else {
                html.classList.remove('dark');
            }
        },

        setupSystemListener() {
            window
                .matchMedia('(prefers-color-scheme: dark)')
                .addEventListener('change', () => {
                    if (this.preference === 'system') {
                        this.applyTheme();
                    }
                });
        },

        async saveToServer() {
            try {
                await window.ApiService.apiCall(
                    '/user-settings/theme-preference',
                    'put',
                    {
                        theme_preference: this.preference,
                    }
                );
            } catch (error) {
                console.warn('Failed to save theme preference to server:', error);
            }
        },
    },
});
